import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App.tsx';
import { initPostHog } from './lib/posthog';
import { initFeatureFlags } from './lib/featureToggles';
import './index.css';

import outputs from '../amplify_outputs.json';

try {
  Amplify.configure(outputs);
} catch (e) {
  console.warn('Amplify configuration failed.', e);
}

// Initialize feature flags and analytics
initFeatureFlags().finally(() => {
  initPostHog();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});